import MuiDialogTitle from '@material-ui/core/DialogTitle';

export default MuiDialogTitle;
